import * as authentication from "./Authentication";
import * as application from "./Application";
import * as clipboard from "./Clipboard";
import * as component from "./Component";
import * as dashboard from "./Dashboard";
import * as entity from "./Entity";
import * as flow from "./Flow";
import * as flowSingleStep from "./FlowSingleStep";
import * as geolocations from "./Geolocations";
import * as googleMap from "./google-map/GoogleMap";
import * as loading from "./Loading";
import * as locale from "./Locale";
import * as print from "./Print";
import * as request from "./request/Request";
import * as routing from "./Routing";
import * as scroll from "./Scroll";
import * as siren from "./Siren";
import * as themes from "./Themes";
import * as table from "./Table";
import * as validations from "./Validations";
import * as widget from "./Widget";
import * as windowSize from "./WindowSize";
import * as messages from "./Messages";
import * as modal from "./Modal";
import * as widgetContainer from "./WidgetContainer";
import * as flowContainer from "./FlowContainer";
import * as global from "./Global";
import * as utils from "./Utils";

export default {
    authentication,
    application,
    entity,
    clipboard,
    component,
    dashboard,
    flow,
    flowSingleStep,
    geolocations,
    global,
    googleMap,
    loading,
    locale,
    print,
    request,
    routing,
    scroll,
    siren,
    themes,
    table,
    validations,
    widget,
    windowSize,
    messages,
    modal,
    widgetContainer,
    flowContainer,
    utils
};
